import React from 'react'
import classNames from 'classnames'

interface ITabToggleProps {
  children: React.ReactNode[]
  className?: string
}

const TabToggle: React.FC<ITabToggleProps> = ({children, className}): React.ReactElement => {
  const css = classNames('tab-toggler', className)

  return <div className={css}>{children}</div>
}

export {TabToggle}
